// extracted by mini-css-extract-plugin
export default {"container":"Monitor_container__WOWSL","rows":"Monitor_rows__aYuB+","boxes":"Monitor_boxes__8a0YP","attitude":"Monitor_attitude__ArDuk"};